import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76104dd5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "m-4" }
const _hoisted_2 = { class: "search-section px-5" }
const _hoisted_3 = { class: "search-wrapper" }
const _hoisted_4 = { class: "container-mysongs" }
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = {
  key: 0,
  class: "py-0 col-12"
}
const _hoisted_8 = { class: "text-left" }
const _hoisted_9 = {
  key: 1,
  class: "py-0 col-12"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Helpers", -1))
const _hoisted_11 = { class: "text-left" }
const _hoisted_12 = {
  key: 2,
  class: "py-0 col-12"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Lyrics", -1))
const _hoisted_14 = { class: "text-left" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SongSearchFilter = _resolveComponent("SongSearchFilter")!
  const _component_SongsCounter = _resolveComponent("SongsCounter")!
  const _component_NoSongs = _resolveComponent("NoSongs")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_SongCategories = _resolveComponent("SongCategories")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_hover = _resolveComponent("v-hover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_SongSearchFilter)
      ])
    ]),
    _createVNode(_component_SongsCounter),
    (_ctx.$store.state.mySongs.length === 0)
      ? (_openBlock(), _createBlock(_component_NoSongs, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.filteredMySongs, (song) => {
        return (_openBlock(), _createBlock(_component_v_hover, {
          key: song.uid
        }, {
          default: _withCtx(({ isHovering, props }) => [
            _createVNode(_component_v_card, _mergeProps({
              style: {'--song-border-color': song.bandColor},
              elevation: isHovering ? 20 : 6
            }, props), {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "d-flex justify-content-start" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(song.song), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_v_card_subtitle, { class: "d-flex justify-content-start" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(song.band), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_SongCategories, {
                        categoriesUids: song.categories
                      }, null, 8, ["categoriesUids"])
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      (song.chords || (!song.chords && !song.helpers && !song.lyrics))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createElementVNode("h5", null, _toDisplayString(song.chords ? 'Chords' : ' '), 1),
                            _createElementVNode("pre", _hoisted_8, _toDisplayString(_ctx.replaceInText(song.chords)), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (!song.chords && song.helpers)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _hoisted_10,
                            _createElementVNode("pre", _hoisted_11, _toDisplayString(_ctx.replaceInText(song.helpers)), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (!song.chords && !song.helpers && song.lyrics)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _hoisted_13,
                            _createElementVNode("pre", _hoisted_14, _toDisplayString(_ctx.replaceInText(song.lyrics)), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_v_card_actions, { class: "d-flex align-items-center justify-content-end" }, {
                  default: _withCtx(() => [
                    (_ctx.navigator.onLine)
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 0,
                          variant: "elevated",
                          onClick: ($event: any) => (_ctx.edit(song))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Edit ")
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_btn, {
                      variant: "elevated",
                      color: "primary",
                      onClick: ($event: any) => (_ctx.view(song))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" View ")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1040, ["style", "elevation"])
          ]),
          _: 2
        }, 1024))
      }), 128))
    ])
  ]))
}